/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Tooltip } from 'primereact/tooltip';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Checkbox } from 'primereact/checkbox';
import Strengths from '../../../assets/Brain.png';
// import Goals from '../../../assets/Vector.png';
import DiscussionLogs from '../../../assets/friend.png';
import MetricReview from '../../../assets/graph.png';
// import Triad from '../../../assets/Vector_Triad.png';
import { ROLES, TOOLTIPDISCUSSION, TOOLTIPMETRIC, TOOLTIPSTRENGTH } from '../../../constants';
import {
    selectCurrentEmpid,
    selectCurrentUser,
    selectCurrentUserManagerLevel,
    selectIsPseudoSupervisor,
} from '../../../pages/login/authSlice';
import { CoachingEntityTypes, CoachingTabs } from '../../../utils/typeConstants';
import {
    useGetCoachingGridSearchQuery,
    useGetCoachingSummaryQuery,
    useGetMyActivitySummaryQuery,
} from '../coachingSlice';
import { CoachingSummaryExpandedGrid } from '../coachingSummaryExpandedGrid/CoachingSummaryExpandedGrid';
import NewConversationLog from '../conversationLogs/newConversationLog/NewConversationLog';
import ReadConversationLog from '../conversationLogs/readConversationLog/ReadConversationLog';
import { EmployeeSearchPopUp } from '../employeeSearchPopUp/EmployeeSearchPopUp';
import { GoalGrid } from '../goals/goalGrid/GoalGrid';
import { NewGoal } from '../goals/newGoal/NewGoal';
// import { Triad } from '../goals/newGoal/NewGoal';
import MetricModal from '../metrics/MetricModal';
import { SearchedEmployeType } from '../revGen/type';
import NewStrength from '../strengths/newStrength/NewStrength';
import ReadStrengths from '../strengths/readStrengths/ReadStrengths';
import { StrengthList } from '../strengths/types';
import UpdateStrength from '../strengths/updateStrength/UpdateStrength';
import './CoachingSummary.scss';
import { SelectTeam } from './SelectTeam';
import { saveSCfilDate } from '../../../utils/dateStorage';
import { ManagerSelectionView } from './ManagerSelectionView';
import CapGuidance from './capGuidance/CapGuidance';
import { LoadingSpinner } from '../../../components/loadingSpinner/loadingspinner';

interface CoachingSummaryProps {
    inputMonth: number;
    inputYear: number;
    date: Date;
    setMonth: (month: number) => void;
    setYear: (year: number) => void;
    setDate: (date: Date) => void;
    userParentClient: any[];
    teamOptionId?: string | undefined;
    entityId?: string | undefined;
    entityDate?: string | undefined;
}

export const CoachingSummary = ({
    inputMonth,
    inputYear,
    date,
    setMonth,
    setYear,
    setDate,
    userParentClient,
    teamOptionId,
    entityId,
    entityDate,
}: CoachingSummaryProps) => {
    const [selectedTeam, setSelectedTeam] = useState<string>();
    const [selectTeamList, setSelectTeamList] = useState<any>();
    const [expandedRows, setExpandedRows] = useState<any>();
    const [coachingSummaryList, setCoachingSummaryList] = useState<any>([]);
    const [visible, setVisible] = useState<boolean>(false);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const loggedEmpNum = useSelector(selectCurrentEmpid); //author number
    const loggedEmpUser = useSelector(selectCurrentUser);
    const [searchedEmployee, setSearchedEmployee] = useState<SearchedEmployeType>({
       'employee_name': '',
        'employee_number': '',
        'location': '',
        'job_title': '',
    });
    const [viewState, setViewState] = useState<string>('read');
    const [displayModal, setDisplayModal] = useState(false);
    const [recieverId, setRecieverId] = useState<string>('');
    const [receiverName, setReceiverName] = useState<string>('');
    const [strength, setStrength] = useState<StrengthList | undefined>(undefined);
    const [showConversationModal, setShowConversationModal] = useState<boolean>(false);
    const [showStrengthModal, setShowStrengthModal] = useState<boolean>(false);
    // const [showTriadModal, setShowTriadModal] = useState<boolean>(false);
    const [showGoalsModal, setShowGoalsModal] = useState<boolean>(false);
    const [showMetricModal, setShowMetricModal] = useState<boolean>(false);
    const [parentStrengthViewState, setParentStrengthViewState] = useState('');
    const isPseudoSupervisor = useSelector(selectIsPseudoSupervisor);
    const [selectedEmployee, setSelectedEmploye] = useState<any>('');
    const [selectedDate, setSelectedDate] = useState<any>();
    const [selectedManager, setSelectedManager] = useState('');
    const [isCapGuidanceVisible, setIsCapGuidanceVisible] = useState<boolean>(false);    
    const [metricReceipient, setMetricReceipient] = useState('');
    const [metricYear, setMetricYear] = useState(0);
    const [metricMonth, setMetricMonth] = useState(0);    
    const [showMetricRecordModal, setShowMetricRecordModal] = useState<boolean>(false);
    const [showStrengthRecordModal, setShowStrengthRecordModal] = useState<boolean>(false);
    // const [hirearchy, setHirearchy] = useState<any>({})
    const { data: coachingSummaryGrid, isFetching: coachingSummaryGridFetching } = useGetCoachingSummaryQuery(
        {
            employeeNumber: ROLES.DirectorOrAbove.includes(userManagerLevel) ? selectedManager : loggedEmpNum,
            year: inputYear,
            month: inputMonth,
            flag: isPseudoSupervisor === true || ROLES.Supervisor.includes(userManagerLevel), // true for tl and false Manager
            loggedEmpRole: ROLES.DirectorOrAbove.includes(userManagerLevel) ? 'director' : userManagerLevel,
            selectedTeam: selectedTeam === 'myActivity' ? 'myactivity' : 'myTeamActivity',
        },
        {
            skip:
                !loggedEmpNum ||
                !inputYear ||
                !inputMonth ||
                !selectedTeam ||
                (selectedTeam && selectedTeam === 'search') ||
                (selectedTeam && selectedTeam === 'myactivity'),
        }
    );

    const { data: myActivitySummaryGrid, isFetching: myActivitySummaryGridFetching } = useGetMyActivitySummaryQuery(
        {
            loggedEmpNumber: loggedEmpNum,
            year: inputYear,
            month: inputMonth,
            selectedTeam,
        },
        {
            skip:
                !loggedEmpNum ||
                !inputYear ||
                !inputMonth ||
                !selectedTeam ||
                (selectedTeam && selectedTeam === 'search') ||
                (selectedTeam && selectedTeam === 'myTeamActivity'),
        }
    );

    const { data: searchedEmployeeGrid } = useGetCoachingGridSearchQuery(
        {
            loggedEmpNumber: loggedEmpNum,
            searchedEmpNumber: searchedEmployee?.employee_number,
            year: inputYear,
            month: inputMonth,
            isTeamLead: isPseudoSupervisor === true || ROLES.Supervisor.includes(userManagerLevel), // true for tl and false Manager
        },
        {
            skip: !loggedEmpNum || !searchedEmployee?.employee_number || !inputYear || !inputMonth,
        }
    );

    useEffect(() => {
        if (coachingSummaryGrid) {
            setExpandedRows([]);
            setCoachingSummaryList(coachingSummaryGrid.data);
        }
    }, [coachingSummaryGrid]);

    useEffect(() => {
        if (searchedEmployeeGrid) {
            setCoachingSummaryList(searchedEmployeeGrid.data);
        }
    }, [searchedEmployeeGrid]);
    useEffect(() => {
        if (selectedManager) {
            setSelectedTeam('myTeamActivity');
        }
        if (selectedDate) {
            setDate(selectedDate);
            setMonth(selectedDate.getMonth() + 1);
            setYear(selectedDate.getFullYear());
        }
    }, [selectedDate, selectedManager]);
    useEffect(() => {
        if (myActivitySummaryGrid) {
            const responseData = [...(myActivitySummaryGrid?.data || [])];
            const reorderData = responseData.sort((a: any, b: any) => {
                if (a.employee_number === loggedEmpNum) return -1;
                if (b.employee_number === loggedEmpNum) return 1;
                return 1;
            });
            setCoachingSummaryList(reorderData);
        }
    }, [myActivitySummaryGrid]);

    useEffect(() => {
        if (!selectedTeam || selectedTeam === 'search') {
            setCoachingSummaryList([]);
        }
    }, [selectedTeam]);

    useEffect(() => {
        const searchedUserString: string | null = localStorage.getItem('searchedUser');
        if (selectedTeam === 'search') {
            if (searchedUserString) {
                const searchedUser: SearchedEmployeType = JSON.parse(searchedUserString);
                setVisible(false);
                setSearchedEmployee(searchedUser);
            } else {
                setVisible(true);
            }
        }
        if (selectedTeam === 'myTeamActivity' && ROLES.Supervisor.includes(userManagerLevel)) {
            if (coachingSummaryGrid?.data.length > 0) {
                setExpandedRows(coachingSummaryGrid?.data);
            }
        }
    }, [selectedTeam, coachingSummaryGrid]);
    useEffect(() => {
        if (teamOptionId && entityId && entityDate) {
            const metricDetails = entityId.split('-');
            if(metricDetails.length === 3){
                setMetricReceipient(metricDetails[0]);
                setMetricYear(Number(metricDetails[1]));
                setMetricMonth(Number(metricDetails[2]));
                setDisplayModal(true);
                if(entityDate === CoachingEntityTypes.Metrics.toString())
                    setShowMetricRecordModal(true);
                else if(entityDate === CoachingEntityTypes.Strengths.toString())
                    setShowStrengthRecordModal(true);
                else{
                    setShowMetricRecordModal(false);
                    setShowStrengthRecordModal(false);
                }
            }
        }
    }, [ teamOptionId, entityId, entityDate]);

    const handleReset = () => {
        setSelectedTeam('');
        setDate(new Date());
    };

    const DateOnChange = (e: any) => {
        if (!(e.value instanceof Date) || isNaN(e.value.getTime())) return;
        setDate(e.value);
        setMonth(e.value.getMonth() + 1);
        setYear(e.value.getFullYear());
        saveSCfilDate(e.value);
    };

    const rowExpansionTemplate = (rowData: any) => {
        setSelectedEmploye(rowData);
        return (
            <div className="coaching-subgrid">
                <CoachingSummaryExpandedGrid
                    selectedEmployee={rowData.employee_number}
                    inputYear={inputYear}
                    inputMonth={inputMonth}
                    flag={ROLES.Manager.includes(rowData.userManagerLevel)}
                    handleGridButonClick={handleGridButonClick}
                    selectedEmployeeRole={rowData.manager_level}
                />
            </div>
        );
    };

    const allowExpansion = (rowData: any) => {
        if (rowData.totalAssociateReportee !== null && rowData.totalAssociateReportee > 0) return true;
        else return false;
    };

    const headerTemplate = (header: string, colorcode: string) => {
        return (
            <>
                <div
                    className="header-container"
                    style={{
                        display: 'block',
                        alignItems: 'center',
                        height: '60px',
                        textAlign: 'center',
                        position: 'relative',
                    }}
                >
                    {header === 'strengths' && (
                        <div className="strengths-tool">
                            <img src={Strengths} alt="Strengths" />{' '}
                            <span style={{ color: colorcode }} className="header-text">
                                Strengths
                            </span>
                        </div>
                    )}
                    {header === 'discussion-logs' && (
                        <div className="discussion-tool">
                            <img src={DiscussionLogs} alt="Discussion Logs" />
                            <span style={{ color: colorcode }} className="header-text">
                                Discussions
                            </span>
                        </div>
                    )}
                    {header === 'metric-review' && (
                        <div className="metric-tool">
                            <img src={MetricReview} alt="Metric Review" />{' '}
                            <span style={{ color: colorcode }} className="header-text">
                                Metric Review
                            </span>
                        </div>
                    )}
                    {/* {header === 'goals' && (
                        <div>
                            <img src={Goals} alt="Goals" />
                            <span style={{ color: colorcode }} className="header-text">
                                Goals
                            </span>
                        </div>
                    )}
                    {header === 'triads' && (
                        <div>
                            <img src={Triad} alt="Goals" />
                            <span style={{ color: colorcode }} className="header-text">
                            Coaching Observations
                            </span>
                        </div>
                    )} */}
                    <span className={`${header} question-circle `} style={{ display: 'inline-block' }}>
                        <i className="pi pi-question" style={{ color: 'white' }} />
                    </span>
                </div>
                {header === 'strengths' && (
                    <Tooltip target={`.${header}`} position="top">
                        <div id="coachingSummary" className="tooltip-content">
                            <span
                                style={{
                                    minWidth: '1rem',
                                    display: 'block',
                                    justifyContent: 'space-between',
                                }}
                            >
                                {TOOLTIPSTRENGTH}
                            </span>
                        </div>
                    </Tooltip>
                )}
                {header === 'discussion-logs' && (
                    <Tooltip target={`.${header}`} position="top">
                        <div id="coachingSummary" className="tooltip-content">
                            <span
                                style={{
                                    minWidth: '1rem',
                                    display: 'block',
                                    justifyContent: 'space-between',
                                }}
                            >
                                {TOOLTIPDISCUSSION}
                            </span>
                        </div>
                    </Tooltip>
                )}
                {header === 'metric-review' && (
                    <Tooltip target={`.${header}`} position="top">
                        <div id="coachingSummary" className="tooltip-content">
                            <span
                                style={{
                                    minWidth: '1rem',
                                    display: 'block',
                                    justifyContent: 'space-between',
                                }}
                            >
                                {TOOLTIPMETRIC}
                            </span>
                        </div>
                    </Tooltip>
                )}

                <hr style={{ color: colorcode }} className="border-header" />
                <div style={{ color: colorcode, alignItems: 'center', textAlign: 'center' }}>
                    {header === 'metric-review' && <p>P4P</p>}
                    {header !== 'metric-review' && <p>-</p>}
                </div>
                {header === 'discussion-logs' && selectedTeam === 'myTeamActivity' ? (
                    <div className="ack-container">
                        <Checkbox checked id="ack-class" className="custom-checkbox" readOnly />
                        <label htmlFor="ingredient1" className="ml-2">
                            = CAP Acknowledge
                        </label>
                    </div>
                ) : (
                    <div style={{ display: 'block' }}>&nbsp;</div>
                )}
                {header === 'Coaching 1 on 1' && <p>Conversation</p>}
            </>
        );
    };

    const handleGridButonClick = (
        employeeNumber: string,
        columnName: string,
        isEdit: boolean,
        receiverName: string,
        rowData?: any
    ) => {
        setShowMetricRecordModal(false);
        setShowStrengthRecordModal(false);
        if (ROLES.Supervisor.includes(rowData.manager_level)) {
            const hirearchy = {
                manager: loggedEmpUser,
                teamLead: rowData.employee_name,
                teamLeadId: rowData.employee_number,
                associate: null,
                associateId: null,
            };
            console.log(hirearchy);
            // setHirearchy(hirearchy)
        }

        if (ROLES.Agents.includes(rowData.manager_level)) {
            const hirearchy = {
                manager: loggedEmpUser,
                teamLead: selectedEmployee.employee_name,
                teamLeadId: selectedEmployee.employee_number,
                associate: rowData.employee_name,
                associateId: rowData.employee_number,
            };
            // setHirearchy(hirearchy)
            console.log(hirearchy);
        }
        setRecieverId(employeeNumber);
        setReceiverName(receiverName);
        setDisplayModal(true);
        if (columnName === 'logs') {
            setViewState(isEdit ? 'read' : 'new');
            setParentStrengthViewState(isEdit ? 'read' : 'new');
            setShowMetricModal(false);
            setShowConversationModal(true);
            setShowStrengthModal(false);
            setShowGoalsModal(false);
        } else if (columnName === 'metrics') {
            if (!isEdit && loggedEmpNum === employeeNumber) {
                toast.warning('You cannot create your own Metric Review.');
                setShowConversationModal(false);
                setShowStrengthModal(false);
                setShowGoalsModal(false);
                setShowMetricModal(false);
            } else {
                setShowConversationModal(false);
                setShowStrengthModal(false);
                setShowGoalsModal(false);
                setShowMetricModal(true);
            }
        } else if (columnName === 'goals') {
            setShowConversationModal(false);
            setShowStrengthModal(false);
            setParentStrengthViewState(isEdit ? 'read' : 'new');
            setViewState(isEdit ? 'read' : 'new');
            setShowMetricModal(false);
            setShowGoalsModal(true);
        } else if (columnName === 'strengths') {
            if (!isEdit && loggedEmpNum === employeeNumber) {
                toast.warning('You cannot create your own strengths');
                setViewState('');
                setParentStrengthViewState('');
                setShowStrengthModal(false);
                setShowConversationModal(false);
                setShowGoalsModal(false);
                setShowMetricModal(false);
            } else {
                setViewState(isEdit ? 'read' : 'new');
                setParentStrengthViewState(isEdit ? 'read' : 'new');
                setShowStrengthModal(true);
                setShowConversationModal(false);
                setShowGoalsModal(false);
                setShowMetricModal(false);
            }
        } else if (columnName === 'triads') {
            if (ROLES.OnlyManager.includes(userManagerLevel)) {
                setViewState('new');
                setShowStrengthModal(false);
                setShowConversationModal(false);
                setShowGoalsModal(false);
                setShowMetricModal(false);
                // setShowTriadModal(true)
            } else {
                toast.warning('Only Managers can create Coaching Observations');
            }
        }
    };

    const calculatePercentage = (count: any, totalCount: any) => {
        return Math.round((count / totalCount) * 100);
    };

    const buttonTemplate = (rowData: any, columnName: string, dividerColor: string, target: number) => {
        let countValue = 0;
        let percentage = 0;
        switch (columnName) {
            case 'strengths':
                countValue = rowData.strengthsCount;
                percentage = calculatePercentage(
                    countValue,
                    rowData.totalAssociateReportee ? rowData.totalAssociateReportee : 0
                );
                break;
            case 'logs':
                countValue = rowData.conversationCapCount;
                percentage = calculatePercentage(
                    countValue,
                    rowData.totalAssociateReportee ? rowData.totalAssociateReportee : 0
                );
                break;
            case 'metrics':
                countValue = rowData.metricsCount;
                percentage = calculatePercentage(
                    countValue,
                    rowData.totalAssociateReportee ? rowData.totalAssociateReportee : 0
                );
                break;
            case 'goals':
                countValue = rowData.goalsCount;
                percentage = calculatePercentage(
                    countValue,
                    rowData.totalAssociateReportee ? rowData.totalAssociateReportee : 0
                );
                break;
            case 'triads':
                countValue = rowData.triadsCount;
                percentage = calculatePercentage(
                    countValue,
                    rowData.totalAssociateReportee ? rowData.totalAssociateReportee : 0
                );
                break;
            default:
                countValue = 0;
                percentage = 0;
        }
        const color = rowData[columnName] ? '#2AA154' : '#3F5765';
        return (
            <div style={{ textAlign: 'center' }}>
                <div>
                    <Button
                        type="button"
                        icon={rowData[columnName] ? 'pi pi-pencil' : 'pi pi-plus'}
                        style={{
                            background: 'transparent',
                            border: `${color} 1px solid`,
                            color: `${color}`,
                            width: '30px',
                            height: '30px',
                        }}
                        onClick={() => {
                            handleGridButonClick(
                                rowData.employee_number,
                                columnName,
                                rowData[columnName],
                                rowData.employee_name,
                                rowData
                            );
                        }}
                    />
                </div>
                <div style={{ background: `${dividerColor}`, height: '2px', margin: '10px 0px' }}>&nbsp;</div>
                {columnName === 'triads' && (
                    <div>
                        <p>{countValue}</p>
                    </div>
                )}
                {columnName !== 'triads' &&
                    rowData.totalAssociateReportee !== null &&
                    rowData.totalAssociateReportee !== 0 && (
                        <div className="display-around">
                            <p>
                                {countValue}/{rowData.totalAssociateReportee}
                                {rowData.columnName}
                            </p>
                            <p className={percentage < target ? 'red' : 'green'}>{percentage}%</p>
                        </div>
                    )}
            </div>
        );
    };
    const handleGuidance = () => {
        setIsCapGuidanceVisible(!isCapGuidanceVisible);
    };
    const renderConversationLog = () => {
        if (viewState === 'read') {
            return (
                <ReadConversationLog
                    setViewState={setViewState}
                    setDisplayModal={setDisplayModal}
                    viewState={viewState}
                    displayModal={displayModal}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpUser}
                    recieverId={recieverId}
                    inputYear={inputYear}
                    inputMonth={inputMonth}
                    receiverName={receiverName}
                    via={CoachingTabs.Coaching}
                />
            );
        } else if (viewState === 'new') {
            return (
                <NewConversationLog
                    setViewState={setViewState}
                    setDisplayModal={setDisplayModal}
                    viewState={viewState}
                    displayModal={displayModal}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpUser}
                    recieverId={recieverId}
                    receiverName={receiverName}
                    via={CoachingTabs.Coaching}
                    date={date}
                    coachingEntityId={0}
                    coachingEntityTypeId={CoachingEntityTypes.General}
                />
            );
        }
        return '';
    };
     const renderStrenghtsRecordModal = () => {
            return (
                <ReadStrengths
                    OnViewState={setViewState}
                    OnDisplayModal={setDisplayModal}
                    OnEditStrength={setStrength}
                    displayModal={displayModal}
                    authorId={loggedEmpNum}
                    recieverId={metricReceipient}
                    receiverName={''}
                    month={metricMonth}
                    year={metricYear}
                />
            );
        }
    const renderStrenghtsModals = () => {
        if (viewState === 'read') {
            return (
                <ReadStrengths
                    OnViewState={setViewState}
                    OnDisplayModal={setDisplayModal}
                    OnEditStrength={setStrength}
                    displayModal={displayModal}
                    authorId={loggedEmpNum}
                    recieverId={recieverId}
                    receiverName={receiverName}
                    month={inputMonth}
                    year={inputYear}
                />
            );
        } else if (viewState === 'new') {
            return (
                <NewStrength
                    OnViewState={setViewState}
                    OnDisplayModal={setDisplayModal}
                    displayModal={displayModal}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpUser}
                    recieverId={recieverId}
                    receiverName={receiverName}
                    parentStrengthViewState={parentStrengthViewState}
                    month={inputMonth}
                    year={inputYear}
                    coachingEntityTypeId={CoachingEntityTypes.General}
                    coachingEntityId={0}
                />
            );
        } else if (viewState === 'edit') {
            return (
                <UpdateStrength
                    OnViewState={setViewState}
                    OnDisplayModal={setDisplayModal}
                    displayModal={displayModal}
                    strength={strength}
                    authorName={loggedEmpUser}
                    recieverId={recieverId}
                    receiverName={receiverName}
                    month={inputMonth}
                    year={inputYear}
                />
            );
        }
        return '';
    };

    const renderGoals = () => {
        if (viewState === 'new') {
            return (
                <NewGoal
                    setViewState={setViewState}
                    setDisplayModal={setDisplayModal}
                    displayModal={displayModal}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpUser}
                    recipientId={recieverId}
                />
            );
        }
        return (
            <GoalGrid
                setViewState={setViewState}
                setDisplayModal={setDisplayModal}
                displayModal={displayModal}
                authorId={loggedEmpNum}
                recipientId={recieverId}
                inputYear={inputYear}
                inputMonth={inputMonth}
            />
        );
    };

    const renderMetric = () => {
        return (
            <MetricModal
                setDisplayModal={setDisplayModal}
                displayModal={displayModal}
                authorId={loggedEmpNum}
                recipientId={recieverId}
                inputYear={inputYear}
                inputMonth={inputMonth}
                recipientName={receiverName}
                // via={CoachingTabs.Coaching}
                entityTypeId={CoachingEntityTypes.General}
            />
        );
    };
    const renderMetricwithData = (recieverEmpId:any, year:number, month:number, receiverEmpName:string) => {
        return (
            <MetricModal
                setDisplayModal={setDisplayModal}
                displayModal={displayModal}
                authorId={loggedEmpNum}
                recipientId={recieverEmpId}
                inputYear={year}
                inputMonth={month}
                recipientName={receiverEmpName}
                entityTypeId={CoachingEntityTypes.General}
            />
        );
    };

    const expandDescirption = (rowData: any, expandedRows: any) => {
        if (
            expandedRows &&
            expandedRows.some((expandedRow: any) => expandedRow.employee_number === rowData.employee_number)
        ) {
            return '';
        }
        if (
            rowData.totalAssociateReportee !== null &&
            rowData.totalAssociateReportee > 0 &&
            selectedTeam === 'myTeamActivity'
        ) {
            return <p>Expand to view your team</p>;
        } else return '';
    };
    return (
        <>
            {(ROLES.SupervisorORAgents.includes(userManagerLevel) ||
                ROLES.OnlyManager.includes(userManagerLevel)) && (
                <div className="row mt-4">
                    <div className="col-md-3">
                        <div className="content">
                            <label htmlFor="selectmonth">Month</label>
                            <Calendar
                                id="selectmonth"
                                value={date}
                                onChange={DateOnChange}
                                view="month"
                                maxDate={new Date()}
                                showIcon
                                className="custom-calendar"
                                dateFormat="MM, yy"
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <SelectTeam
                            selectTeamList={selectTeamList}
                            selectedTeam={selectedTeam}
                            setSelectedTeam={setSelectedTeam}
                            setVisible={setVisible}
                            setSelectTeamList={setSelectTeamList}
                            userManagerLevel={userManagerLevel}
                            parent='capstab'
                        />
                    </div>
                    <div className="col-md-3">
                        <Button
                            label="Reset"
                            style={{ fontWeight: 400, marginTop: '30px' }}
                            className="btn-secondary mb-2"
                            onClick={handleReset}
                        />
                    </div>
                </div>
            )}
            {ROLES.DirectorOrAbove.includes(userManagerLevel) && (
                <div className="row">
                    <ManagerSelectionView
                        employeeName={loggedEmpUser}
                        selectedManager={setSelectedManager}
                        selectedDate={setSelectedDate}
                        userParentClient={userParentClient}
                    />
                </div>
            )}
            <div className="d-flex justify-content-between mb-2">
                <p style={{ marginTop: '10px', marginLeft: '39%', marginBottom: '0px' }}>
                    Select a month and team above, click &quot; <i className="pi pi-plus" /> &quot; to add and
                    &quot; <i className="pi pi-pencil" /> &quot; to edit
                </p>
                <Button
                    label="What is a CAP?"
                    icon="ConversationGuidelinesIcon"
                    onClick={() => setIsCapGuidanceVisible(true)}
                    className="btn-primary me-4"
                />
            </div>
            <div>{coachingSummaryGridFetching ? <LoadingSpinner /> : ''}</div>
            <div>{myActivitySummaryGridFetching ? <LoadingSpinner /> : ''}</div>
            <div className="row">
                <DataTable
                    value={coachingSummaryList}
                    id="coaching-summary"
                    rows={5}
                    paginator={coachingSummaryList?.length > 5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    emptyMessage="No records found."
                    rowExpansionTemplate={rowExpansionTemplate}
                    expandedRows={expandedRows}
                    onRowToggle={(e) => {
                        setExpandedRows(e.data);
                    }}
                >
                    <Column field="employee_name" style={{ width: '10rem' }} />
                    <Column
                        header={headerTemplate('strengths', '#A9A5FF')}
                        field="strengths"
                        style={{ width: '5rem' }}
                        body={(rowData: any) => buttonTemplate(rowData, 'strengths', '#A9A5FF', 80)}
                    />

                    <Column
                        header={headerTemplate('metric-review', '#F93')}
                        field="metrics"
                        style={{ width: '5rem' }}
                        body={(rowData: any) => buttonTemplate(rowData, 'metrics', '#F93', 100)}
                    />
                    <Column
                        header={headerTemplate('discussion-logs', '#3299FF')}
                        field="logs" //aka : Discussions
                        style={{ width: '5rem' }}
                        body={(rowData: any) => buttonTemplate(rowData, 'logs', '#3299FF', 100)}
                    />
                    <Column key="expand" expander={allowExpansion} style={{ width: '1rem' }} />
                    <Column
                        style={{ width: '4rem' }}
                        body={(data) => expandDescirption(data, expandedRows)}
                    />
                </DataTable>
            </div>
            {visible && (
                <EmployeeSearchPopUp
                    visible={visible}
                    searchedEmployee={searchedEmployee}
                    setVisible={setVisible}
                    setSelectedTeam={setSelectedTeam}
                    setSearchedEmployee={setSearchedEmployee}
                />
            )}
            {showConversationModal && renderConversationLog()}
            {showStrengthModal && renderStrenghtsModals()}
            {showGoalsModal && renderGoals()}
            {showMetricModal && renderMetric()}
            {showMetricRecordModal && renderMetricwithData(metricReceipient, metricYear, metricMonth, '')}
            {showStrengthRecordModal && renderStrenghtsRecordModal()}
            {/* {showTriadModal && renderTriadModal()} */}
            {isCapGuidanceVisible && (
                <CapGuidance isCapGuidanceVisible={isCapGuidanceVisible} onHide={handleGuidance} />
            )}
        </>
    );
};
